import { createFileRoute } from '@tanstack/react-router';

import {
  Advertiser,
  AdvertiserSearchParamsSchema,
} from '@/features/trafficking';

export const Route = createFileRoute('/_app/trafficking/advertiser')({
  validateSearch: AdvertiserSearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <Advertiser />;
}
